// /opt/ptg01-v1/front-extranet/lib/QueryProvider.tsx
// Provider TanStack Query — cache + dedup + revalidation pour /api/me/*.
// Stale time 30 s par défaut (raisonnable pour données mensuelles + CRA + dépenses).
// Refetch on window focus désactivé en dev (bruit), activé en prod via env.
'use client';

import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function QueryProvider({ children }: { children: React.ReactNode }) {
    // Lazy init — évite de partager un client entre requêtes serveur (SSR safety).
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30 * 1000,                // 30 s — réduit les calls /api/me redondants
                gcTime: 5 * 60 * 1000,                // 5 min — cache mémoire après dernière utilisation
                refetchOnWindowFocus: process.env.NODE_ENV === 'production',
                retry: (failureCount, error) => {
                    // Pas de retry sur 401/403/404 — l'auth ou la ressource n'existe pas
                    if (error instanceof Response && [401, 403, 404].includes(error.status)) return false;
                    return failureCount < 2;
                },
            },
            mutations: {
                retry: false, // mutations idempotentes uniquement (pas de retry pour POST/PATCH/DELETE)
            },
        },
    }));

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}
